<template>
  <v-btn
      @click="onClick"
      text
      v-bind="$attrs"
  >
    <span v-if="showDeletedLocal">
      <v-icon v-if="!!onIcon">{{onIcon}}</v-icon>
      <span v-if="!!onText">{{onText}}</span>
    </span>
    <span v-else>
      <v-icon v-if="!!offIcon">{{offIcon}}</v-icon>
      <span v-if="!!offText">{{offText}}</span>
    </span>
  </v-btn>
</template>

<script>

export default {
  name: 'BaseTextSwitch',
  inheritAttrs: false,
  props: {
    value: {default: null},
    onText: {default: 'On'},
    onIcon: {default: null},
    offText: {default: 'Off'},
    offIcon: {default: null},
  },

  components: {},

  computed: {
  },

  methods: {
    onClick(event) {
      // console.log('onClick', event)
      this.showDeletedLocal = !this.showDeletedLocal
      this.$emit('input', this.showDeletedLocal)
    },
  },

  async mounted() {

  },

  data() {
    return {
      showDeletedLocal: this.value
    }
  }
}
</script>

<style scoped lang="scss">
</style>
